import style from "./style.scss";
import { Fragment } from "preact";
import { formatDateLong, formatISODate } from "../../components/helpers";
import { Link } from "preact-router";
import NoWrap from "../../components/no-wrap";
import ElectricalDisclosure from "../../components/electrical-disclosure";
import { mergeClasses } from "../helpers";
import namedRoutes from "../../settings/routes";

const Author = ({
  author = false,
  img = "/images/author.webp",
  name = "Tyson Matanich",
  published,
  updated = null,
  preText = null,
}) => {
  const wasUpdated = updated && published != updated;
  const info = [];

  if (!author && preText) {
    info.push(<span>{preText}</span>);
  }

  if (wasUpdated) {
    info.push(
      <NoWrap>
        Updated:{" "}
        <time datetime={formatISODate(updated)} itemprop="dateModified">
          {formatDateLong(updated)}
        </time>
      </NoWrap>
    );
  }

  if (published && (author || !wasUpdated)) {
    info.push(
      <NoWrap>
        Published:{" "}
        <time datetime={formatISODate(published)} itemprop="datePublished">
          {formatDateLong(published)}
        </time>
      </NoWrap>
    );
  }

  return author ? (
    <Fragment>
      <ElectricalDisclosure />
      <hr />
      <div class={style.authorDate}>
        <div class={style.wrapper}>
          <div class={style.image}>
            <img src={img} alt={name} />
          </div>
          <div class={style.info}>
            <div class={style.textWrapper}>
              <div class={style.author} itemprop="name">
                {name == "Tyson Matanich" ? (
                  <Link href={namedRoutes.about}>{name}</Link>
                ) : (
                  name
                )}
              </div>
              <div class={style.date}>
                {info.map((item, index) => (
                  <Fragment key={index}>
                    {item}
                    {index < info.length - 1 && ", "}
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  ) : (
    <p class={mergeClasses([style.date, style.onlyDate])}>
      {info.map((item, index) => (
        <Fragment key={index}>
          {item}
          {index < info.length - 1 && ", "}
        </Fragment>
      ))}
    </p>
  );
};

export default Author;
